import React, { useEffect, useRef, useState } from "react";
import { Alert, Stack, Button, Paper, Box, Typography } from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { auth } from "firebaseApp";
import {
  signInWithPopup,
  GoogleAuthProvider,
  onAuthStateChanged,
  signOut,
} from "firebase/auth";
import { useDispatch } from "react-redux";
import { userActions } from "../store/user";
import { useSelector } from "react-redux";
import { colors } from "colors";
import EmailPasswordAuthForm from "components/react-lib/firebase-auth/EmailPasswordAuthForm";
import Logo from "components/svg/Logo";
import { fonts } from "fonts";
import useIsMobile from "hooks/react-lib/generic-ui/useIsMobile";
import GoogleLoginButton from "components/react-lib/firebase-auth/GoogleLoginButton";
import { useTheme } from "@emotion/react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "context/react-lib/firebase-auth/AuthProvider";
import LogRocket from 'logrocket';

export default function Auth() {

  // const auth = useAuth();
  const theme = useTheme();
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);

  const googleAuthProvider = new GoogleAuthProvider();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();

  const installPromptEventRef = useRef();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        LogRocket.identify(user.uid, {
          name: user.displayName,
          email: user.email,
        });
        dispatch(
          userActions.login({
            uid: user.uid,
          })
        );
        navigate("/"); // Redirect to home page if user is authenticated
      } else {
        dispatch(userActions.logout());
      }
    });

    return () => unsubscribe(); // Cleanup the listener on unmount
  }, [dispatch, navigate]);

  const loginWithGoogle = async () => {
    setError();
    setIsLoading(true);
    try {
      await signInWithPopup(auth, googleAuthProvider);
    } catch (error) {
      console.log(error);
      setError("Could not login it. Try again later.");
    }
    setIsLoading(false);
  };

  const logout = async () => {
    await signOut(auth);
  };

  const renderButton = () => {
    if (user.uid) {
      return (
        <Button
          color="primary"
          variant="contained"
          startIcon={<ExitToAppIcon />}
          onClick={logout}
          disabled={isLoading}
        >
          Logout
        </Button>
      );
    }
    return (
      <Button
        data-testid="google-login-button"
        variant="contained"
        color="secondary"
        startIcon={<GoogleIcon />}
        onClick={loginWithGoogle}
        disabled={isLoading}
      >
        Login with Google
      </Button>
    );
  };

  useEffect(() => {
    window.addEventListener("beforeinstallprompt", (e) => {
      installPromptEventRef.current = e;
    });  
  }, []);

  
  return (
    <Stack
      direction={isMobile ? "column" : "row"}
      sx={{
        height: "100vh",
        width: "100vw",
        backgroundColor: colors.black,
        position: "relative",
      }}
      justifyContent="center"
      alignItems="center"
      spacing={isMobile ? 2 : 5}
    >
      {error && <Alert severity="error">{error}</Alert>}
      <Stack
        alignItems="center"
        justifyContent="center"
      >
        <Typography color={theme.palette.text.main} fontFamily={fonts.anton} fontSize="2rem">Cheap-GPT</Typography>
        <Logo
          style={{
            width: "100px",
          }}
        />
        <Typography color={theme.palette.text.main} variant="caption" fontSize="1rem">Your subscription-free door to AI</Typography>
       
      </Stack>

      <Paper
        sx={{
          zIndex: 1000,
          width: "250px",
        }}
      >
        <Stack p={2} spacing={2}>
          <EmailPasswordAuthForm />

          <GoogleLoginButton 
            loginProps={{
              color: "primary",
            }}
          />
        </Stack>
      </Paper>
    </Stack>
  );
}
